/** Public export for the WHO HAS ACCESS row (SE-8313). */
export { default } from "./ShareAccessRowContainer";
export type { ShareAccessRowContainerProps } from "./ShareAccessRowContainer";
